export const greyColor = '#706b6b';

export const AppStyle = theme => ({
    logo: {
        textAlign: 'center',
        marginBottom: `${theme.spacing.unit * 5}px`,
        '& img': {
            height: `200px`
        }
    },
});
